// src/components/UsageGuide.js
// 앱 사용 방법 안내 모달 — 정적 콘텐츠라 API 호출이 없다.
// 서비스 규칙이 바뀌면 이 문구도 함께 갱신해야 한다.
import React from 'react';
import '../styles/UsageGuide.css';

const UsageGuide = ({ onClose }) => {
    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('usage-guide-overlay')) {
            onClose();
        }
    };

    return (
        <div className="usage-guide-overlay" onClick={handleOverlayClick}>
            <div className="usage-guide-modal">
                <div className="modal-header">
                    <h2>❓ 사용 방법</h2>
                    <button onClick={onClose} className="modal-close-btn">✕</button>
                </div>

                <div className="usage-guide-content">
                    <section className="guide-step">
                        <div className="guide-step-badge">1</div>
                        <div className="guide-step-body">
                            <h3>💕 시작하기 — 커플 매칭</h3>
                            <p>
                                한 명이 <strong>초대 코드를 생성</strong>하고, 상대방이 그 코드를 입력하면 매칭이 완료됩니다.
                            </p>
                            <ul>
                                <li>초대 코드는 발급 후 <strong>24시간</strong> 동안 유효합니다.</li>
                                <li>본인이 만든 코드로는 입장할 수 없습니다. 상대방에게 전달해주세요.</li>
                            </ul>
                        </div>
                    </section>

                    <section className="guide-step">
                        <div className="guide-step-badge">2</div>
                        <div className="guide-step-body">
                            <h3>📝 일기 쓰기</h3>
                            <p>매칭이 끝나면 두 사람이 함께 보는 일기를 쓸 수 있습니다.</p>
                            <ul>
                                <li>같은 날짜에는 <strong>하루 한 편</strong>만 작성할 수 있습니다.</li>
                                <li>일기 날짜는 오늘까지 선택할 수 있습니다. (지난 날의 기록도 가능)</li>
                                <li>작성할 때 <strong>타임캡슐 개봉일</strong>을 함께 정합니다. (기본값: 일주일 뒤)</li>
                                <li>
                                    두 사람이 한 일기에 <strong>이어서</strong> 쓸 수 있고, 각자 쓴 부분은
                                    <strong> 각자의 글자 색</strong>으로 표시되어 누가 쓴 글인지 한눈에 구분됩니다.
                                </li>
                                <li>내 글자 색은 <strong>프로필 수정 → 글자 색</strong>에서 고를 수 있습니다.</li>
                            </ul>
                        </div>
                    </section>

                    <section className="guide-step">
                        <div className="guide-step-badge">3</div>
                        <div className="guide-step-body">
                            <h3>🎁 타임캡슐 남기기</h3>
                            <p>일기마다 두 사람이 각자 하나씩 비밀 메시지를 남길 수 있습니다.</p>
                            <ul>
                                <li>
                                    <strong>상대방이 쓴 내용은 개봉일 전까지 볼 수 없습니다.</strong> 그때까지의 설렘도 함께 보관되는 셈이에요.
                                </li>
                                <li>작성·수정·삭제는 <strong>개봉일 전까지만</strong> 가능합니다.</li>
                            </ul>
                        </div>
                    </section>

                    <section className="guide-step">
                        <div className="guide-step-badge">4</div>
                        <div className="guide-step-body">
                            <h3>📬 개봉과 메일</h3>
                            <p>
                                개봉일이 되면 <strong>오전 9시</strong>에 두 사람 모두에게 메일이 발송됩니다.
                                일기와 양쪽 타임캡슐 내용이 함께 담겨 있습니다.
                            </p>
                            <ul>
                                <li>메일을 받을 주소는 <strong>프로필 수정 → 알림 이메일</strong>에서 바꿀 수 있습니다.</li>
                                <li>개봉일 이후에는 앱에서도 서로의 타임캡슐을 볼 수 있습니다.</li>
                            </ul>
                        </div>
                    </section>

                    <section className="guide-faq">
                        <h3>💬 자주 묻는 질문</h3>

                        <details className="faq-item">
                            <summary>초대 코드가 만료됐어요</summary>
                            <p>커플 매칭 화면에서 코드를 다시 생성하면 됩니다. 새 코드가 발급되고 이전 코드는 사용할 수 없게 됩니다.</p>
                        </details>

                        <details className="faq-item">
                            <summary>개봉일이 됐는데 메일이 오지 않아요</summary>
                            <p>
                                프로필 수정 화면에서 <strong>알림 이메일</strong>이 실제로 받을 수 있는 주소인지 확인해주세요.
                                주소가 맞다면 스팸함도 확인해보시고, 그래도 없다면 잠시 후 다시 확인해주세요.
                            </p>
                        </details>

                        <details className="faq-item">
                            <summary>글자 색을 바꾸면 예전에 쓴 일기도 바뀌나요?</summary>
                            <p>
                                네. 글자 색은 항상 <strong>현재 설정</strong>을 따르기 때문에,
                                프로필에서 색을 바꾸면 이전에 쓴 글도 모두 새 색으로 표시됩니다.
                            </p>
                        </details>

                        <details className="faq-item">
                            <summary>커플을 탈퇴하면 일기는 어떻게 되나요?</summary>
                            <p>
                                함께 쓴 일기와 타임캡슐을 <strong>더 이상 볼 수 없게</strong> 됩니다.
                                다시 매칭하더라도 이전 데이터는 복원되지 않으니 신중하게 결정해주세요.
                            </p>
                        </details>
                    </section>
                </div>

                <div className="usage-guide-actions">
                    <button type="button" className="guide-close-btn" onClick={onClose}>
                        확인했어요
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UsageGuide;
